/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum RuleRouteRestrictionPointType {
    Station = 'Station',
    Location = 'Location',
    Country = 'Country',
    Region = 'Region'
}

export function RuleRouteRestrictionPointTypeFromJSON(json: any): RuleRouteRestrictionPointType {
    return RuleRouteRestrictionPointTypeFromJSONTyped(json, false);
}

export function RuleRouteRestrictionPointTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleRouteRestrictionPointType {
    return json as RuleRouteRestrictionPointType;
}

export function RuleRouteRestrictionPointTypeToJSON(value?: RuleRouteRestrictionPointType | null): any {
    return value as any;
}

